import React, { useState } from 'react';
import { Alert, AlertTitle, Box, Fade } from '@mui/material';

/**
 * A floating alert component that can be dismissed on click
 * @param {Object} props - Component properties
 * @param {string} props.severity - Alert severity ('error', 'warning', 'info', 'success')
 * @param {string} props.title - Alert title
 * @param {string} props.message - Alert message
 * @param {boolean} props.initialShow - Initial visibility state
 * @returns {JSX.Element} Floating alert component
 */
const FloatingAlert = ({ 
  severity = 'primary', 
  title, 
  message, 
  initialShow = true 
}) => {
  const [show, setShow] = useState(initialShow);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Fade in={show}>
      <Box
        sx={{
          position: 'fixed',
          top: '80px', // Position below the header
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          width: '90%',
          maxWidth: '600px',
        }}
      >
        <Alert 
          severity={severity} 
          variant="standard" 
          onClick={handleClose}
          sx={{ 
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', 
            borderRadius: '4px',
            cursor: 'pointer',
            position: 'relative',
            '&:hover': {
              boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
            },
          }}
        >
          {title && <AlertTitle>{title}</AlertTitle>}
          {message}
          <Box 
            sx={{ 
              position: 'absolute', 
              bottom: 4, 
              right: 8, 
              fontSize: '0.75rem',
              opacity: 0.4
            }}
          >
            (Click to dismiss)
          </Box>
        </Alert>
      </Box>
    </Fade>
  );
};

export default FloatingAlert;
